import React, { useEffect, useRef, useState } from "react";

export const CAR_COLORS = [
  { name: "Blanc", hex: "#F5F5F5" },
  { name: "Noir", hex: "#141414" },
  { name: "Gris", hex: "#9AA0A6" },
  { name: "Argent", hex: "#C9CDD4" },
  { name: "Bleu", hex: "#2563EB" },
  { name: "Rouge", hex: "#DC2626" },
  { name: "Vert", hex: "#16A34A" },
  { name: "Jaune", hex: "#EAB308" },
  { name: "Orange", hex: "#EA580C" },
  { name: "Marron", hex: "#7C4A2D" },
  { name: "Beige", hex: "#D8C9A8" },
  { name: "Or", hex: "#D4AF37" },
  { name: "Bordeaux", hex: "#7B1E2B" },
  { name: "Violet", hex: "#7C3AED" },
];

// Premium color dropdown with a swatch palette + free-text "custom" option.
export default function ColorSelect({ value, onChange, placeholder = "— Choisir —", testid = "color-select", className = "" }) {
  const [open, setOpen] = useState(false);
  const [customMode, setCustomMode] = useState(false);
  const ref = useRef(null);
  const match = CAR_COLORS.find((c) => c.name.toLowerCase() === (value || "").toLowerCase());
  const isCustom = customMode || (!!value && !match);
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  return (
    <div ref={ref} className="relative" data-testid={testid}>
      <button type="button" data-testid={`${testid}-trigger`} onClick={() => setOpen((o) => !o)}
        className={`flex h-10 w-full items-center gap-2 rounded-md border bg-white/5 px-3 text-sm text-white outline-none focus:border-primary ${className || "border-white/10"}`}>
        {match ? (
          <span className="inline-block h-4 w-4 shrink-0 rounded-full border border-white/25" style={{ background: match.hex }} />
        ) : value ? (
          <span className="inline-block h-4 w-4 shrink-0 rounded-full border border-white/25 bg-gradient-to-br from-slate-300 to-slate-500" />
        ) : null}
        <span className={value ? "text-white" : "text-white/40"}>{value || placeholder}</span>
        <svg className={`ml-auto h-4 w-4 shrink-0 text-white/50 transition-transform ${open ? "rotate-180" : ""}`} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 8l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </button>
      {open && (
        <div className="absolute z-50 mt-2 w-full overflow-hidden rounded-xl border border-white/10 bg-pactly-ink2 shadow-2xl shadow-black/50 backdrop-blur-xl" data-testid={`${testid}-menu`}>
          <div className="grid max-h-64 grid-cols-2 gap-1 overflow-auto p-2">
            {CAR_COLORS.map((c) => (
              <button key={c.name} type="button" data-testid={`${testid}-opt-${c.name.toLowerCase()}`}
                onClick={() => { onChange(c.name); setCustomMode(false); setOpen(false); }}
                className={`flex items-center gap-2 rounded-lg px-2.5 py-2 text-left text-sm transition-colors hover:bg-white/10 ${match && match.name === c.name ? "bg-white/10 ring-1 ring-pactly-violet/50" : ""}`}>
                <span className="inline-block h-5 w-5 shrink-0 rounded-full border border-white/25 shadow-inner" style={{ background: c.hex }} />
                <span className="text-white/90">{c.name}</span>
              </button>
            ))}
          </div>
          <div className="border-t border-white/10 p-2">
            <button type="button" data-testid={`${testid}-opt-custom`}
              onClick={() => { setCustomMode(true); if (match) onChange(""); setOpen(false); }}
              className={`flex w-full items-center gap-2 rounded-lg px-2.5 py-2 text-left text-sm transition-colors hover:bg-white/10 ${isCustom ? "bg-white/10 ring-1 ring-pactly-violet/50" : ""}`}>
              <span className="inline-block h-5 w-5 shrink-0 rounded-full border border-white/25 bg-gradient-to-br from-fuchsia-400 via-sky-400 to-emerald-400" />
              <span className="text-white/90">Autre / personnalisé…</span>
            </button>
          </div>
        </div>
      )}
      {isCustom && (
        <input data-testid={`${testid}-custom-input`} value={match ? "" : (value || "")} onChange={(e) => onChange(e.target.value)}
          placeholder="Saisir une couleur"
          className="mt-2 h-10 w-full rounded-md border border-pactly-violet/40 bg-white/5 px-3 text-sm text-white outline-none focus:border-primary" />
      )}
    </div>
  );
}
